<div *ngIf="!init" style="align-self: center">
  <mat-spinner style="margin: auto" color="primary" diameter="24"></mat-spinner>
</div>
<div *ngIf="init" [ngClass]="displayListClass">
  <ul class="inpress-ul">
    <li
      *ngFor="
        let item of itemGroup.items;
        let index = index;
        trackBy: trackById
      "
    >
      <span
        class="clickable project-popup-entry"
        [class.appointment-info]="item.appointmentInfoDisplay?.length > 0"
        [matTooltip]="item.appointmentInfoDisplay"
        [matTooltipPosition]="'above'"
        [matTooltipClass]="'preserve-line-break'"
        [matTooltipDisabled]="
          item.appointmentInfoDisplay == null ||
          item.appointmentInfoDisplay.length === 0
        "
        (click)="displayChild(index)"
        >{{ item.popupDisplay }}</span
      >
    </li>
  </ul>
</div>
<ng-container
  *ngFor="let item of itemGroup.items; let index = index; trackBy: trackById"
>
  <immo-map-popup-info
    [index]="index"
    [item]="item"
    [toggleDisplay]="toggleDisplay"
    [alwaysDisplay]="alwaysDisplay"
    [placerOptions]="placerOptions"
    (backPressed)="backPressed()"
    (itemPlanned)="itemPlanned($event)"
    (placerUpdated)="placerUpdated($event)"
  ></immo-map-popup-info>
</ng-container>
